import { trackKey } from '../../../../services/studentTracksModel';

/**
 * The timed words for the file that is playing (2026-09-27, the second
 * screen's scroll). A saved key ("Up 2") carries no words of its own but
 * shares its original's timeline exactly (the tempo never changes), so it
 * borrows them through `keyOf`. Null when there are no TIMED words: a track
 * whose lyrics are text only must not take over the second screen.
 */
export const timedLyricsOf = (file, files = []) => {
	const ok = (l) => l && Array.isArray(l.timed) && l.timed.length > 0;
	if (!file) return null;
	const list = Array.isArray(files) ? files : [];
	// THE PLAYER HOLDS THE FILE AS IT WAS WHEN PLAY STARTED (useTrackPlayer's
	// setCurrent), and a lyrics job can land its words on the pointer minutes
	// later: the page re-reads the docs when the job files, but the snapshot in
	// the player never changes, and every reader here was handed that snapshot.
	// So read the words from the CURRENT copy of the same file first. Found
	// 2026-10-05 on Maddy's cut: the strip said "Words timed for the second
	// screen", the stage said "Ready", the section row said "once this track's
	// words are timed", all at once, until the track was reselected.
	const key = trackKey(file);
	const fresh = key ? list.find((f) => f && f !== file && trackKey(f) === key) || null : null;
	if (fresh && ok(fresh.lyrics)) return fresh.lyrics;
	if (ok(file.lyrics)) return file.lyrics;
	const keyOf = (fresh && fresh.keyOf) || file.keyOf;
	if (keyOf) {
		const original = list.find((f) => f && f.storagePath === keyOf);
		if (original && ok(original.lyrics)) return original.lyrics;
	}
	return null;
};

/** The song a file belongs to, for the stage's heading. */
export const songNameForFile = (docs = [], file) => {
	if (!file) return '';
	const key = trackKey(file);
	const doc = (Array.isArray(docs) ? docs : []).find((d) => (d.files || []).some((f) => trackKey(f) === key));
	return (doc && doc.songName) || '';
};

/** What the stage needs to switch to this track's words. */
export const lyricsMessage = ({ key, file, files, title, t = 0, playing = false }) => {
	const lyrics = timedLyricsOf(file, files);
	if (!lyrics || !key) return null;
	return {
		type: 'lyrics',
		key,
		title: title || '',
		lines: lyrics.timed.map((l) => ({ t: Number(l.t) || 0, text: String(l.text || '') })),
		unverified: Boolean(lyrics.unverified),
		t: Number(t) || 0,
		playing: Boolean(playing),
	};
};
